const cache = new Map();
const k = (url, opts) => {
  const o = opts || {};
  const h = o.headers ? Object.entries(o.headers).sort((a,b)=>a[0].localeCompare(b[0])) : [];
  const q = JSON.stringify({ m: o.method || 'GET', h, b: o.body || null });
  return `${url}::${q}`;
};
export async function cachedFetchJson(url, opts = {}, ttlMs = 30000) {
  const key = k(url, opts);
  const now = Date.now();
  const ent = cache.get(key);
  if (ent && now - ent.ts < ttlMs) return ent.data;
  const res = await fetch(url, opts);
  const ct = res.headers.get('content-type') || '';
  const isJson = ct.includes('application/json');
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      msg = isJson ? ((await res.json()).error || msg) : (await res.text());
    } catch {}
    throw new Error(msg);
  }
  const data = isJson ? await res.json() : await res.text();
  cache.set(key, { ts: now, data });
  return data;
}
export async function cachedAxiosGet(axios, url, opts = {}, ttlMs = 30000) {
  const headers = opts.headers || {};
  const key = `${url}::${JSON.stringify({ headers, params: opts.params || null })}`;
  const now = Date.now();
  const ent = cache.get(key);
  if (ent && now - ent.ts < ttlMs) return ent.data;
  const { data } = await axios.get(url, opts);
  cache.set(key, { ts: now, data: { data } });
  return { data };
}
